module.exports = __webpack_public_path__ + "img/life-at-ommax-4.b02fd0d4.jpg";